<template>
  <div class="documentViewer" ref="pdfDiv"></div>
</template>

<script>
import Pdf from './pdf.ts';
export default Pdf;
</script>

<style src="./pdf.css"/>
